import { render, staticRenderFns } from "./OganizationInformation.vue?vue&type=template&id=47c0e6b4&scoped=true"
import script from "./OganizationInformation.vue?vue&type=script&lang=js"
export * from "./OganizationInformation.vue?vue&type=script&lang=js"
import style0 from "./OganizationInformation.vue?vue&type=style&index=0&id=47c0e6b4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47c0e6b4",
  null
  
)

export default component.exports